module.exports = __webpack_public_path__ + "static/media/radiobutton_blue.cfc034d3.svg";